import {
    GetGoodsMixBasicInfo,
    GetGoodsMixLikeInfo,
    GetGoodsMixPropInfo,
    GetGoodsMixServiceFeeNew,
} from "@/pages/page1/api/modules/goods";
import {
    AddShopCart,
    IsCollection,
    DelCollection,
    AddCollection,
} from "@/pages/page1/api/modules/shoppingCart";
import City from "@/pages/page1/components/city.vue";
import SameGoods from "../components/sameGoods.vue";
import Recommended from "../components/recommended.vue";
import GoodsItr from "../components/goodsItr.vue";
import SeeOriginalPrice from "../components/seeOriginalPrice.vue";
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
import onlyMessage from '@/pages/publicUtils/resetMessage.js'
import BackTop from "@/pages/page1/components/backTop";
import {
    Swiper,
    SwiperSlide
} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    metaInfo() {
        return {
            title: this.pageName + " - 多比商城"
        };
    },
    name: "goodsDetails",
    components: {
        Swiper,
        SwiperSlide,
        City,
        DialogLogin,
        SameGoods,
        Recommended,
        GoodsItr,
        SeeOriginalPrice,
        BackTop
    },
    data() {
        return {
            showLoading: true,
            swiperOption: {
                spaceBetween: 12, //间隔距离
                autoplay: false,
                // // loop:true,
                slidesPerView: 5,
            },
            activeIndex: 0,
            dataBreadcrumb: [], // 面包屑数据

            basicData: {}, // 获取到的商品总数据
            attrInfo: {
                attr1Info: {},
                attr2Info: {},
                attr3Info: {},
                attr4Info: {},
            },
            attrNumber: 0, //控制attr
            goodsInfo: {}, // 商品介绍
            goodsCount: 0, //商品数量
            rate: 5,
            colors: ["#D00000", "#D00000", "#D00000", "#D00000", "#D00000"],

            currentMix: {}, // 当前选中商品
            videoSrc: "", // 视频
            showVideo: false,
            effectImg: "", // 效果图展示
            effectBanner: [], // 效果图轮播
            localImgIndex: 0, //当前效果图图片索引

            isShowService: false, // 选中服务
            serviceFee: 0, //服务费
            freightFee: undefined, //运费
            btnDis: false, // 按钮可控制
            loading: false, //加购load

            isCollectionId: null, // 商品收藏的id null未被收藏 有id被收藏
            recomMix: [], //推荐搭配
            seriesLike: [], // 同系
            stylesLike: [], // 类似
            classList: [],
            queryMixSerNo: undefined, //url参数

            regionCode: undefined,
            isSeePrice: false, //查看采购价权限
            pageName: "商品详情",
        };
    },
    mounted() {
        this.queryMixSerNo = this.$route.params.mixSerNo.substring(
            0,
            this.$route.params.mixSerNo.indexOf(".")
        );
        // console.log('参数',this.queryMixSerNo);
        this.getGoodsDetailList(this.queryMixSerNo);
        this.getGoodsLikeList(this.queryMixSerNo);
        this.getGoodsMixPropInfo(this.queryMixSerNo);
        if (this.$cookies.isKey("ACCESS_TOKEN")) {
            this.isSeePrice = this.$store.state.userInfo.isShowTradePrice ? true : false
        }
    },
    methods: {
        // 不需要登录
        getGoodsDetailList(mixSerNo) {
            let params = {
                mixId: null,
                mixSerNo: mixSerNo,
            };
            this.showLoading = true
            GetGoodsMixBasicInfo(params).then((res) => {
                // console.log("获取某个商品信息", res);
                let data = res.data[0];
                // 保存原始数据
                this.basicData = data;
                // 四个属性
                if (data.attrs.attr1Info) {
                    this.actionAttr(data, "attr1Info");
                    this.attrNumber += 1;
                }
                if (data.attrs.attr2Info) {
                    this.actionAttr(data, "attr2Info");
                    this.attrNumber += 1;
                }
                if (data.attrs.attr3Info) {
                    this.actionAttr(data, "attr3Info");
                    this.attrNumber += 1;
                }
                if (data.attrs.attr4Info) {
                    this.actionAttr(data, "attr4Info");
                    this.attrNumber += 1;
                }
                // 初始化使用mixId相同的组合（就是商品编号的数据）
                let initialMix = data.mixs.find((v) => data.mixId == v.id);
                this.currentMix = initialMix;
                this.attrInfo.attr1Info.currentId = initialMix.attr1ContentId;
                this.attrInfo.attr2Info.currentId = initialMix.attr2ContentId;
                this.attrInfo.attr3Info.currentId = initialMix.attr3ContentId;
                this.attrInfo.attr4Info.currentId = initialMix.attr4ContentId;
                // 初始化展示数据
                this.writeData(this.currentMix, data);
                // 找到不存在的，不能点击
                this.findDisabled();
                if (this.$cookies.isKey("ACCESS_TOKEN")) {
                    // 获取商品是否被收藏
                    this.getIsCollection(this.currentMix.id);
                }
                this.showLoading = false
            }).catch(() => this.showLoading = false)
        },
        compare(propertyName, Desc) {
            //根据哪个属性值排序
            return function (obj1, obj2) {
                //对象两两比较 升序
                let value1 = obj1[propertyName];
                let value2 = obj2[propertyName];
                if (Desc) return value2 - value1;
                return value1 - value2;
            };
        },
        actionAttr(data, attr) {
            data.attrs[attr].contentList.sort(this.compare("sortOrder"));
            data.attrs[attr].contentList.forEach((v) => {
                this.$set(v, "isDisabled", false);
            });
            this.attrInfo[attr] = data.attrs[attr];
            this.$set(this.attrInfo[attr], "currentId", null);
        },
        writeData(resItem, data) {
            // 推荐搭配
            this.recomMix = data.goodsInfo.recomMix
            // 商品介绍
            this.goodsInfo = data.goodsInfo;
            this.pageName = this.goodsInfo.name + "-" + resItem.mixName;
            this.goodsInfo.materialName = data.goodsInfo.materialNameList.join("+");
            this.goodsInfo.keyWords = data.goodsInfo.keyWordsArr.join(" ");
            this.goodsInfo.startPlace =
                data.goodsInfo.sendProvinceName + " " + data.goodsInfo.sendCityName;
            // 面包屑
            this.dataBreadcrumb.push({
                path: "/category",
                name: "全部产品",
                query: {},
            });
            this.dataBreadcrumb.push({
                path: "/category",
                name: data.goodsInfo.categoryName,
                query: {
                    categorySerNo: data.goodsInfo.categorySerNo
                },
            });
            this.dataBreadcrumb.push({
                path: "/category",
                name: data.goodsInfo.brandName,
                query: {
                    brandSerNos: data.goodsInfo.brandSerNo
                },
            });
            // 视频
            if (resItem.videoList.length > 0) {
                this.videoSrc = resItem.videoList[0].filePath;
            } else {
                this.videoSrc = "";
            }
            // 效果图轮播
            if (resItem.preImage.length == 0) {
                this.effectBanner = [];
                this.effectImg = require("@/assets/img/error-goods.jpg");
                return false;
            }
            this.effectBanner = resItem.preImage;
            // 主图排第一
            this.effectBanner.sort(this.compare("isMain", true));
            this.effectImg = this.effectBanner[0].filePath;
        },
        getGoodsLikeList(mixSerNo) {
            let params = {
                mixId: null,
                mixSerNo: mixSerNo,
                mixCount: 6
            };
            GetGoodsMixLikeInfo(params).then((res) => {
                // console.log("获取相似商品", res);
                this.seriesLike = this.sliceArr(res.data[0].seriesLike);
                this.stylesLike = res.data[0].stylesLike;
            });
        },
        sliceArr(arr) {
            let result = [];
            for (var i = 0; i < arr.length; i += 3) {
                result.push(arr.slice(i, i + 3));
            }
            return result;
        },
        getGoodsMixPropInfo(mixSerNo) {
            let params = {
                mixId: null,
                mixSerNo: mixSerNo,
            };
            GetGoodsMixPropInfo(params).then((res) => {
                // console.log("获取规格参数", res.data);
                this.classList = res.data;
            });
        },
        getEndPlace(val) {
            // console.log(val);
            this.regionCode = val
            this.getGoodsMixServiceFee();
        },
        //是否上门安装
        changeService() {
            if (!this.regionCode) {
                onlyMessage.warning("请选择收货地址")
                return
            }
            this.isShowService = !this.isShowService
            if (this.isShowService) this.getGoodsMixServiceFee();
        },
        onChangeCount() {
            if (!this.regionCode) return
            this.getGoodsMixServiceFee()
        },
        getGoodsMixServiceFee() {
            let shoppingCartList = [];
            shoppingCartList.push({
                goodsMixId: this.currentMix.id,
                goodsCount: this.goodsCount,
            });
            GetGoodsMixServiceFeeNew({
                shoppingCartList,
                regionCode: this.regionCode
            }).then((res) => {
                // console.log("获取服务费", res);
                this.serviceFee = res.data[0].serviceFee;
                this.freightFee = res.data[0].freightFee;
            });
        },
        // change四个属性
        changeAttr(item, attr) {
            attr.currentId = item.id;
            let resItem = this.basicData.mixs.find(
                (v) =>
                v.attr1ContentId == this.attrInfo.attr1Info.currentId &&
                v.attr2ContentId == this.attrInfo.attr2Info.currentId &&
                v.attr3ContentId == this.attrInfo.attr3Info.currentId &&
                v.attr4ContentId == this.attrInfo.attr4Info.currentId
            );
            if (!resItem) return;
            if (this.queryMixSerNo != resItem.serNo) {
                // 刷新
                let newUrl = this.$router.resolve({
                    name: "goodsDetails",
                    params: {
                        mixSerNo: resItem.serNo + ".html"
                    },
                });
                window.open(newUrl.href, "_self");
            }
        },
        findDisabled() {
            switch (this.attrNumber) {
                case 1:
                    this.forEachAttr1();
                    break;
                case 2:
                    this.forEachAttr1();
                    this.forEachAttr2();
                    break;
                case 3:
                    this.forEachAttr1();
                    this.forEachAttr2();
                    this.forEachAttr3();
                    break;
                case 4:
                    this.forEachAttr1();
                    this.forEachAttr2();
                    this.forEachAttr3();
                    this.forEachAttr4();
                    break;
            }
        },
        forEachAttr1() {
            this.attrInfo.attr1Info.contentList.forEach((v) => {
                let result = this.basicData.mixs.find((item) => {
                    return (
                        item.attr1ContentId == v.id &&
                        item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
                        item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
                        item.attr4ContentId == this.attrInfo.attr4Info.currentId
                    );
                });
                v.isDisabled = false;
                if (!result) {
                    v.isDisabled = true;
                }
            });
        },
        forEachAttr2() {
            this.attrInfo.attr2Info.contentList.forEach((v) => {
                let result = this.basicData.mixs.find((item) => {
                    return (
                        item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
                        item.attr2ContentId == v.id &&
                        item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
                        item.attr4ContentId == this.attrInfo.attr4Info.currentId
                    );
                });
                v.isDisabled = false;
                if (!result) {
                    v.isDisabled = true;
                }
            });
        },
        forEachAttr3() {
            this.attrInfo.attr3Info.contentList.forEach((v) => {
                let result = this.basicData.mixs.find((item) => {
                    return (
                        item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
                        item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
                        item.attr3ContentId == v.id &&
                        item.attr4ContentId == this.attrInfo.attr4Info.currentId
                    );
                });
                v.isDisabled = false;
                if (!result) {
                    v.isDisabled = true;
                }
            });
        },
        forEachAttr4() {
            this.attrInfo.attr4Info.contentList.forEach((v) => {
                let result = this.basicData.mixs.find((item) => {
                    return (
                        item.attr1ContentId == this.attrInfo.attr1Info.currentId &&
                        item.attr2ContentId == this.attrInfo.attr2Info.currentId &&
                        item.attr3ContentId == this.attrInfo.attr3Info.currentId &&
                        item.attr4ContentId == v.id
                    );
                });
                v.isDisabled = false;
                if (!result) {
                    v.isDisabled = true;
                }
            });
        },
        // 登录
        updateLogin(isLogin) {
            // console.log(isLogin);
            if (isLogin) {
                location.reload();
            }
        },
        addShoppingCart(id, shopNumber) {
            if (this.$cookies.isKey("ACCESS_TOKEN")) {
                let params = {
                    goodsMixId: id,
                    goodsMixCount: shopNumber,
                    regionCode: this.regionCode || localStorage.getItem("_regionCode"),
                };
                this.loading = true;
                AddShopCart(params)
                    .then((res) => {
                        // console.log("加入购物车结果", res);
                        onlyMessage.success("加入成功");
                        this.loading = false;
                        this.$store.commit("SET_SHOPCARTNUM");
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                this.showDiaLogin()
            }
        },
        buyShop() {
            if (this.$cookies.isKey("ACCESS_TOKEN")) {
                // console.log(111, this.currentMix);
                let buyGoodObj = [];
                buyGoodObj.push({
                    goodsBrandId: this.goodsInfo.brandId,
                    goodsBrandName: this.goodsInfo.brandName,
                    shoppingCartList: [],
                });
                buyGoodObj.forEach((v) => {
                    v.shoppingCartList.push({
                        id: "1", //伪造购物车id
                        goodsCount: this.goodsCount,
                        goodsMixId: this.currentMix.id,
                    });
                });
                let time = new Date().getTime();
                localStorage.setItem("selectGoods_" + time, JSON.stringify(buyGoodObj));
                let newUrl = this.$router.resolve({
                    path: "/placeOrder",
                    query: {
                        id: time
                    },
                });
                window.open(newUrl.href, "_blank");
            } else {
                this.showDiaLogin()
            }
        },
        getIsCollection(goodsMixId) {
            IsCollection({
                goodsMixId
            }).then((res) => {
                // console.log("判断商品是否被收藏", res);
                this.isCollectionId = res.data[0];
            });
        },
        followGoods(goodsMixId) {
            if (this.$cookies.isKey("ACCESS_TOKEN")) {
                if (this.isCollectionId) {
                    DelCollection({
                        id: this.isCollectionId
                    }).then((res) => {
                        // console.log("取消收藏", res);
                        this.getIsCollection(goodsMixId);
                    });
                } else {
                    // 这里不用清除购物记录
                    AddCollection({
                        goodsMixId
                    }).then((res) => {
                        // console.log("移入收藏", res);
                        this.getIsCollection(goodsMixId);
                    });
                }
            } else {
                this.showDiaLogin()
            }
        },
        // 视频处理
        playVideo() {
            this.showVideo = true;
            this.$refs.video.play();
        },
        pauseVideo(index) {
            if (this.localImgIndex != index) {
                this.localImgIndex = index;
                this.effectImg = this.effectBanner[index].filePath;
            }
            this.showVideo = false;
            this.$refs.video.pause();
        },
        prevSlide() {
            this.$refs.mySwiper.$swiper.slidePrev();
        },
        nextSlide() {
            this.$refs.mySwiper.$swiper.slideNext();
        },
        // 监听swiper的激活项变化
        onTransitionStart(val) {
            this.activeIndex = val.activeIndex;
        },
        onSeePrice() {
            if (this.isSeePrice) this.$refs.seePrice.seePrice(this.queryMixSerNo)
        },
        showDiaLogin() {
            this.$refs.diaLogin.elVisible = true;
        },
    },
};